import React, { useState } from "react";

import AudioPlayer from "react-h5-audio-player";

import Button from "components/form/Button";

import AudioIcon from "icons/document/AudioIcon";
import MuteIcon from "icons/document/MuteIcon";
import PauseIcon from "icons/document/PauseIcon";
import PlayIcon from "icons/document/PlayIcon";
import VolumeIcon from "icons/document/VolumeIcon";
import { DownloadIcon } from "icons/payments/DownloadIcon";

import "react-h5-audio-player/lib/styles.css";

interface AudioPreviewProps {
  audioUrl: string;
  newTitle?: string;
  isDownloading?: boolean;
  isPreviewLoading?: boolean;
  onDownloadClick: (path: string, fileName: string, id?: string) => void;
  docTitle: string;
  id?: string;
  isDownloaded?: boolean;
}

const AudioPreview = ({
  audioUrl,
  newTitle,
  isDownloading = false,
  isPreviewLoading = false,
  onDownloadClick,
  docTitle,
  id,
  isDownloaded = false,
}: AudioPreviewProps) => {
  const [loadError, setLoadError] = useState<boolean>(false);

  const downloadButtonImg = isPreviewLoading ? (
    <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
  ) : (
    <DownloadIcon strokeColor="var(--color-bg-primary)" width="22" height="22" />
  );

  return (
    <div className="lg:!w-[482px] w-full h-full flex flex-col items-center lg:justify-center gap-10 ">
      {loadError ? (
        <>
          <div className="w-full h-full flex flex-col items-center justify-center gap-10">
            <AudioIcon />
            <div className="w-full flex flex-col gap-4 items-center justify-center ">
              <p className="w-full text-xl font-medium text-txtPrimary text-center">
                Preview unavailable
              </p>
              <p className="w-full text-base text-txtSecondary text-center">
                Please download the audio to listen to it.
              </p>
            </div>
            <div className="w-full grid place-items-center">
              <Button
                text={isPreviewLoading ? "Downloading…" : "Download"}
                className="!w-fit"
                isDisabled={isDownloading}
                isLoading={false}
                isSuccess={isDownloaded}
                img={downloadButtonImg}
                onClick={() => {
                  onDownloadClick(docTitle, newTitle || docTitle, id);
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="lg:pt-0 pt-[100px] w-full flex flex-col items-center lg:justify-center gap-10">
          <AudioIcon />
          <div className="w-full text-center flex flex-col gap-6 text-xl font-medium text-txtPrimary !px-[30px]">
            {newTitle}
            <AudioPlayer
              src={audioUrl}
              showJumpControls={false}
              style={{
                backgroundColor: "transparent",
                boxShadow: "none",
                border: "none",
              }}
              customAdditionalControls={[]}
              customIcons={{
                play: <PlayIcon />,
                volume: <VolumeIcon />,
                volumeMute: <MuteIcon />,
                pause: <PauseIcon />,
              }}
              onError={() => setLoadError(true)}
            />
          </div>
          <div className="w-full grid place-items-center">
            <Button
              text={isPreviewLoading ? "Downloading…" : "Download"}
              className="!w-fit"
              isDisabled={isDownloading}
              isLoading={false}
              isSuccess={isDownloaded}
              img={downloadButtonImg}
              onClick={() => {
                onDownloadClick(docTitle, newTitle || docTitle, id);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AudioPreview;
